import { getLocaleFromPath } from './localePathPrefix';
import type { BookingLanguageCode } from './i18n';

/** #1120 — préfixe URL → locale ; sans préfixe → fr (pas le localStorage). */
export function resolveUiLanguageForPath(
  pathname: string,
  _storedPreferred?: string | null | undefined
): BookingLanguageCode {
  const fromPath = getLocaleFromPath(pathname);
  if (fromPath) return fromPath;
  return 'fr';
}

export function urlLocaleOverridesPreference(pathname: string): boolean {
  return getLocaleFromPath(pathname) != null;
}
